/**
 * @module profile/components/portfolio/portfolio_entry_info
 */
import React, { PropTypes } from 'react';

/**
 * Component to show basic info of a portfolio entry which we can reuse
 * across the portfolio views. It should be wrapped in an element with `row` class.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const PortfolioEntryInfo = ({ entry }) => (
  <div className="portfolio-entry-info">
    <h4>{ entry.title }</h4>
    <div className="project-categories">
      {entry.industry &&
      <span className="tag tag-default tag-sm">{ entry.industry.slug }</span>}

      {entry.sub_category &&
      <span className="tag tag-default tag-sm">{ entry.sub_category.slug }</span>}
    </div>
    {/* FIXME: we don't have these numbers in the backend, so commenting them out for now. */}
    {/*
    <div className="small-16 column entry-stats">
      <span className="watchers">
        <i className="fa fa-eye" aria-hidden="true" />
        3
      </span>
      <span className="likes">
        <i className="fa fa-thumbs-up" aria-hidden="true" />
        4
      </span>
    </div> */}
  </div>
);

/**
 * PropTypes.
 *
 * @property {object} entry - entry data object
 */
PortfolioEntryInfo.propTypes = {
  entry: PropTypes.object,
};

export default PortfolioEntryInfo;



// WEBPACK FOOTER //
// ./profile/components/portfolio/portfolio_entry_info.jsx